import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {RouterModule} from '@angular/router';
import {HttpClientModule} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {LayoutModule} from '@angular/cdk/layout';
import {MarkdownModule} from "ngx-markdown";

import {DirectivesModules} from './shared/directives/directives.module';
import {ComponentsModules} from './shared/components/components.module';
import {PipesModules} from "./shared/pipes/pipes.modules";
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';

import {ApiInjectables} from './shared/services/api/api.injectables';
import {AudioInjectables} from './shared/services/audio/audio.injectables';
import {BackBtnInjectables} from "./shared/services/back-btn/back-btn.injectables";
import {BearInjectables} from './shared/services/bear/bear.injectables';
import {BoardInjectables} from './shared/services/board/board.injectables';
import {CordovaInjectables} from './shared/services/cordova/cordova.injectables';
import {DynamicComponentInjectables} from "./shared/services/dynamic-component/dynamic-component.injectables";
import {FcmInjectables} from './shared/services/fcm/fcm.injectables';
import {GreetingInjectables} from "./shared/services/greeting/greeting.injectables";
import {HanjaInjectables} from "./shared/services/hanja/hanja.injectables";
import {HomonymInjectables} from './shared/services/homonym/homonym.injectables';
import {HttpInterceptorInjectables} from './shared/services/http-interceptor/http-interceptor.injectables';
import {LastIdInjectables} from "./shared/services/last-id/last-id.injectables";
import {LayoutMgrInjectables} from './shared/services/layout-mgr/layout-mgr.injectables';
import {ListHelpInjectables} from './shared/services/list-help/list-help.injectables';
import {NativeVideoInjectables} from "./shared/services/native-video/native-video.injectables";
import {NaverLoginInjectables} from "./shared/services/naver-login/naver-login.injectables";
import {NotiInjectables} from "./shared/services/noti/noti.injectables";
import {OptionInjectables} from './shared/services/option/option.injectables';
import {PitchInjectables} from './shared/services/pitch/pitch.injectables';
import {ProverbInjectables} from './shared/services/proverb/proverb.injectables';
import {RecorderInjectables} from "./shared/services/recorder/recorder.injectables";
import {ResizeInjectables} from './shared/services/resize/resize.injectables';
import {SaseungHangulInjectables} from "./shared/services/saseung-hangul/saseung-hangul.injectables";
import {SaseungHanjaInjectables} from "./shared/services/saseung-hanja/saseung-hanja.injectables";
import {ScrollDownInjectables} from "./shared/services/scroll-down/scroll-down.injectables";
import {SnsInjectables} from "./shared/services/sns/sns.injectables";
import {SystemInjectables} from './shared/services/system/system.injectables';
import {TfSpiceInjectables} from './shared/services/tf-service/tf-spice.injectables';
import {TotalInjectables} from './shared/services/total/total.injectables';
import {UserInjectables} from './shared/services/user/user.injectables';
import {VideoInjectables} from './shared/services/video/video.injectables';
import {VoiceInjectables} from './shared/services/voice/voice.injectables';
import {WordInjectables} from './shared/services/word/word.injectables';
import {YoutubeInjectables} from './shared/services/youtube/youtube.injectables';

import {WordModule} from './word/word.module';
import {OptionsModule} from './options/options.module';
import {MovieCollectModule} from './movie-collect/movie-collect.module';
import {ExampleModule} from './example/example.module';

import {DonationComponent} from './donation/donation.component';
import {OpenSourceComponent} from './open-source/open-source.component';
import {LicenseViewComponent} from './open-source/license-view.component';
import {CallbackModule} from './callback/callback.module';
import {LegalNoticeComponent} from './legal-notice/legal-notice.component';
import {AdminMsgComponent} from './admin-msg/admin-msg.component';


@NgModule({
  declarations: [
    AppComponent,
    DonationComponent,
    OpenSourceComponent,
    LicenseViewComponent,
    LegalNoticeComponent,
    AdminMsgComponent,
  ],
  imports: [
    BrowserModule,
    RouterModule,
    HttpClientModule,
    BrowserAnimationsModule,
    LayoutModule,
    MarkdownModule.forRoot(),
    DirectivesModules,
    ComponentsModules,
    PipesModules,
    AppRoutingModule,
    // MainModule,
    // TotalModule,
    WordModule,
    OptionsModule,
    MovieCollectModule,
    ExampleModule,
    // ProverbModule,
    // DialectModule,
    // BoardModule,
    CallbackModule,
    // LinkModule,
  ],
  providers: [
    ApiInjectables,
    AudioInjectables,
    BackBtnInjectables,
    BearInjectables,
    BoardInjectables,
    CordovaInjectables,
    DynamicComponentInjectables,
    FcmInjectables,
    GreetingInjectables,
    HanjaInjectables,
    HomonymInjectables,
    HttpInterceptorInjectables,
    LastIdInjectables,
    LayoutMgrInjectables,
    ListHelpInjectables,
    NativeVideoInjectables,
    NaverLoginInjectables,
    NotiInjectables,
    OptionInjectables,
    PitchInjectables,
    ProverbInjectables,
    RecorderInjectables,
    ResizeInjectables,
    SaseungHangulInjectables,
    SaseungHanjaInjectables,
    ScrollDownInjectables,
    SnsInjectables,
    SystemInjectables,
    TfSpiceInjectables,
    TotalInjectables,
    UserInjectables,
    VideoInjectables,
    VoiceInjectables,
    WordInjectables,
    YoutubeInjectables,
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
